import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["apiCreateStep", "fullFormStep"]
  static values = {
    taskId: String
  }

  connect() {
    console.log('AI Task Wizard controller connected')
    console.log("[AI Task Wizard] Connected with taskId:", this.taskIdValue)

    const isNewRecord = this.isNewRecord()
    if (isNewRecord) {
      this.showApiCreateStep()
    } else {
      this.showFullForm()
    }
    this.bindApiCreateForm()
    this.observeIconPreview()
  }

  disconnect() {
    if (this.iconPreviewObserver) {
      this.iconPreviewObserver.disconnect()
    }
  }
  

  isNewRecord() {
    const mainForm = document.querySelector('form[action*="ai_tasks"]')
    if (mainForm && mainForm.action.includes('/new')) {
      return true
    }

    const wizardElement = this.element
    if (wizardElement.dataset.newRecord === 'true') {
      return true
    }

    const fullFormStep = document.getElementById('full-form-step')
    if (fullFormStep && fullFormStep.classList.contains('d-none')) {
      return true
    }

    return false
  }

  showApiCreateStep() {
    const apiCreateStep = document.getElementById('api-create-step')
    const fullFormStep = document.getElementById('full-form-step')

    if (apiCreateStep) apiCreateStep.classList.remove('d-none')
    if (fullFormStep) fullFormStep.classList.add('d-none')
  }

  showFullForm() {
    const apiCreateStep = document.getElementById('api-create-step')
    const fullFormStep = document.getElementById('full-form-step')

    if (apiCreateStep) apiCreateStep.classList.add('d-none')
    if (fullFormStep) fullFormStep.classList.remove('d-none')

    if (!this.isNewRecord()) {
      const quickCreateSection = document.querySelector('.bg-light.p-3.mb-4.rounded')
      if (quickCreateSection) quickCreateSection.classList.add('d-none')
    }
  }

  skipToFullForm() {
    console.log('Skip button clicked')
    this.showFullForm()
  }

  bindApiCreateForm() {
    const apiCreateForm = document.querySelector('form[action*="api_create_ai_tasks"]')
    if (apiCreateForm) {
      apiCreateForm.addEventListener('submit', (event) => {
        event.preventDefault()
        this.handleApiCreateSubmit(event)
      })
    }
  }

  handleApiCreateSubmit(event) {
    const form = event.target
    const formData = new FormData(form)
    const messageInput = form.querySelector('input[name="message"]')
    const message = messageInput ? messageInput.value.trim() : ''

    if (!message) {
      this.showError('Please enter a message describing what you want to automate.')
      return
    }

    this.showLoading(true)

    fetch(form.action, {
      method: form.method,
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        'Accept': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        this.showLoading(false)

        if (data.success) {
          this.populateFullFormFromApiResponse(data)
          this.showFullForm()
          this.showSuccess('AI task details generated! Review and adjust the fields below.')
        } else {
          this.showError(data.error || 'Failed to generate task. Please try again.')
        }
      })
      .catch(error => {
        this.showLoading(false)
        console.error('Error:', error)
        this.showError('An error occurred. Please try again.')
      })
  }

  populateFullFormFromApiResponse(data) {
    if (data.name) {
      const nameField = document.querySelector('input[name="ai_task[name]"]')
      if (nameField) nameField.value = data.name
    }

    if (data.description) {
      const descriptionField = document.querySelector('input[name="ai_task[description]"]')
      if (descriptionField) descriptionField.value = data.description
    }

    if (data.prompt_message) {
      const promptField = document.querySelector('textarea[name="ai_task[prompt_message]"]')
      if (promptField) promptField.value = data.prompt_message
    }

    if (data.icon) {
      const iconField = document.querySelector('input[name="ai_task[icon]"]')
      const iconDisplay = document.querySelector('#selected-icon-display')
      if (iconField) iconField.value = data.icon
      if (iconDisplay) {
        iconDisplay.className = data.icon
        iconDisplay.classList.remove('d-none')
      }
    }

    if (data.search !== undefined) {
      const searchToggle = document.querySelector('input[name="ai_task[search]"]')
      if (searchToggle) {
        searchToggle.checked = data.search
        if ($(searchToggle).data('toggle') === 'toggle') {
          $(searchToggle).bootstrapToggle(data.search ? 'on' : 'off')
        }
      }
    }
  }

  showLoading(show) {
    const apiCreateStep = document.getElementById('api-create-step')
    const submitButton = apiCreateStep?.querySelector('button[type="submit"], input[type="submit"]')
    const skipButton = apiCreateStep?.querySelector('[data-action*="skipToFullForm"]')

    if (show) {
      if (submitButton) {
        submitButton.disabled = true
        submitButton.innerHTML = '<i class="fas fa-spinner fa-spin mr-1"></i> Generating...'
      }
      if (skipButton) skipButton.disabled = true
    } else {
      if (submitButton) {
        submitButton.disabled = false
        submitButton.innerHTML = 'Create Task'
      }
      if (skipButton) skipButton.disabled = false
    }
  }

  showError(message) {
    this.showMessage(message, 'danger')
  }

  showSuccess(message) {
    this.showMessage(message, 'success')
  }

  showMessage(message, type = 'info') {
    const existingAlerts = document.querySelectorAll('.wizard-alert')
    existingAlerts.forEach(alert => alert.remove())

    const alertDiv = document.createElement('div')
    alertDiv.className = `alert alert-${type} alert-dismissible fade show wizard-alert mt-3`
    alertDiv.innerHTML = `
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    `

    const currentStep = document.querySelector('.wizard-step:not(.d-none)')
    if (currentStep) {
      currentStep.appendChild(alertDiv)
    }

    if (type === 'success') {
      setTimeout(() => {
        if (alertDiv.parentNode) alertDiv.remove()
      }, 5000)
    }
  }
  observeIconPreview() {
    const container = this.element // .icon-preview-wrapper element itself
  
    if (!container) {
      console.warn("[AI Task Wizard] No icon preview wrapper found")
      return
    }
  
    console.log("[AI Task Wizard] Observing icon preview wrapper")
  
    const observer = new MutationObserver((mutations) => {
      console.log("[AI Task Wizard] Mutation observed:", mutations)
      this.syncIconField()
    })
  
    observer.observe(container, { childList: true, subtree: true })
    this.iconPreviewObserver = observer
  }
  

  getTaskId() {
    const preview = document.querySelector('[id^="select-icon-display-"]')
    if (!preview) return ''
    const idParts = preview.id.split('select-icon-display-')
    return idParts.length > 1 ? idParts[1] : ''
  }
}
